const mEditionMapActivation = {
  mEditionMapActivation: {
    alerts: {
      updateContenidoActivarNodos: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Los días de entrega fueron editados exitosamente.'
      }
    },

    buttonPrimary: {
      nodo: 'GUARDAR'
    },

    immediate: {
      disableAll: 'Desactivar todos',
      enableAll: 'Activar todos:'
    },

    messages: {
      activeOne: 'La activación de cada contenido se realizará tomando en cuenta el día de entrega + la fecha de inicio del mapa',
      activeZero: 'La activación de cada contenido se realizará tomando en cuenta la fecha de inscripción del alumno + el día de entrega.'
    },

    quote: {
      firstText: 'Aún no tienes caminos creados en tu mapa.',
      secondText: 'Para configurar los días de activación primero debes crear caminos ingresando a',
      thirdText: 'La activación de cada contenido se realizará tomando en cuenta la fecha de inicio del mapa de aprendizaje.'
    },

    titles: {
      days: 'Configura los días de entrega para tus caminos'
    }
  }
}

export default mEditionMapActivation
